import { render, staticRenderFns } from "./JobEditPreviewMessage.vue?vue&type=template&id=240166ca"
import script from "./JobEditPreviewMessage.vue?vue&type=script&lang=js"
export * from "./JobEditPreviewMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports